import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import S from 'calendar.scss';

/* eslint-disable jsx-a11y/no-static-element-interactions */
const CalendarDayCell = ({
  children, className, onSelect, selectedRow, selectedCol, selectable,
}) => <div
  onClick={onSelect}
  className={cx(S.dayCell, className, {
    [S.selectedRow]: selectedRow,
    [S.selectedCol]: selectedCol,
    [S.selectable]: selectable,
  })}
>{children}</div>;

CalendarDayCell.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  selectedRow: PropTypes.bool,
  selectedCol: PropTypes.bool,
  selectable: PropTypes.bool,
};

CalendarDayCell.defaultProps = { onSelect: () => {} };

export default CalendarDayCell;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/components/calendarDayCell.jsx